import Icon from '@susu/headless-commerce/components/Icon/Icon'
import { ClientNavBack } from './ClientNavBack'

export const NavBack = () => {
  return (
    <ClientNavBack>
      <Icon icon="arrow_left" aria-hidden="true" />
      <span className="sr-only">Back</span>
    </ClientNavBack>
  )
}
